export function birthdayBounds(today = new Date()) {
  const anniversary = (yearsAgo) => {
    const year = today.getFullYear() - yearsAgo;
    const month = today.getMonth();
    const day = Math.min(today.getDate(), new Date(year, month + 1, 0).getDate());
    return new Date(year, month, day);
  };
  const min = anniversary(111);
  min.setDate(min.getDate() + 1);
  return { min, max: anniversary(18) };
}

export function birthdayMonth(cursor, { min, max }) {
  const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
  const earliest = new Date(min.getFullYear(), min.getMonth(), 1);
  const latest = new Date(max.getFullYear(), max.getMonth(), 1);
  return new Date(Math.max(earliest.getTime(), Math.min(latest.getTime(), first.getTime())));
}
